import {Avatar, Space} from 'antd'
import {getType} from 'apis/model/base'
import classNames from 'classnames'
import DrawMenu from 'components/drawer/DrawMenu'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {IoSettingsOutline, IoTrashOutline} from 'react-icons/io5'
import CustomButton from 'views/AppLocals/custom/CustomButton'
import {OverlayItemBanner} from 'views/AppLocals/Templates/ItemTemplate'
import {NullAsDefault, renderElse} from 'views/Shared'
import HostContext, {HostActionTypes} from '../HostContext'
import HostContent from './HostContent'

const HostActionContainer = React.memo(({params, children}) => {
    const {handleAction = NullAsDefault} = useContext(HostContext)

    return _.isFunction(children)
        ? children((action) => handleAction(action, params))
        : children
})

const PendingItem = ({handleClick = NullAsDefault}) => {
    const t = useTranslate()
    return (
        <Space direction="horizontal">
            <CustomButton
                size="small"
                ghost={true}
                onClick={() => {
                    handleClick(HostActionTypes.APPROVE)
                }}
                label="approve"
                color="primary" variant="filled"
                textSize="text-sm md:text-xs"
            />
            <CustomButton
                size={'small'}
                ghost={true}
                onClick={() => {
                    handleClick(HostActionTypes.DECLINE)
                }}
                label="reject"
                color="default" variant="text"
                textSize="text-sm md:text-xs"
            />
        </Space>
    )
}

const ApprovedItem = ({canLeave, handleClick = NullAsDefault}) => {
    const t = useTranslate()

    const menu = useMemo(
        () =>
            [
                !!canLeave
                    ? {
                        key: HostActionTypes.LEAVE,
                        label: t('leave'),
                        icon: <IoTrashOutline className="text-red-500"/>,
                    }
                    : undefined,
            ].filter((value) => value),
        [t, canLeave]
    )

    return renderElse(
        _.isEmpty(menu),
        <DrawMenu
            menu={
                {
                    items: menu,
                    onClick: ({key}) => {
                        handleClick(key)

                    }
                }
            }
            component={
                <Avatar
                    size={22}
                    icon={<IoSettingsOutline size={14} className="text-color-400 hover:text-color-100"/>}
                    className="flex flex-center background hover:background-200 cursor-pointer"
                />
            }>

        </DrawMenu>
    )
}

const renderActions = (status, handleClick = NullAsDefault, params) => {
    const {canLeave} = params || {}

    let Component
    switch (Number(status)) {
        case 1:
            Component = ApprovedItem
            break
        case -1:
            Component = PendingItem
            break
        default:
            Component = NullAsDefault
            break
    }
    return <Component {...{canLeave, handleClick}} />
}

const HostActionRow = ({
                           item,
                           params,
                           status,
                           subItem,
                           Actions,
                           canLeave = true,
                           ...rest
                       }) => {

    const actions = useMemo(() => {
        if (Actions) {
            return (
                <Actions
                    {...{item, subItem}}
                    {...rest}
                />
            )
        }
        return (
            <HostActionContainer {...{params}}>
                {(handleClick) => renderActions(status, handleClick, {canLeave})}
            </HostActionContainer>
        )
    }, [item, rest, params, status, Actions, subItem])

    const hostType = getType(item)

    if (_.isEmpty(item)) return null

    return (
        <div className="p-2 flex flex-col custom-item-render border border-color-50 hover:scale-3xs hover:shadow rounded-lg relative">
            <HostContent
                {...{
                    item,
                    status,
                    subItem,
                }}
            />
            <div className="absolute right-10 top-10 contextIcon">
                {actions}
            </div>
        </div>
    )
}

export const HostRow = ({
                            showInfo,
                            showLabel = true,
                            type = 'host',
                            item,
                            style,
                            className,
                        }) => {
    if (_.isEmpty(item)) {
        return null
    }
    const {host, owner} = item || {}
    const hostType = getType(host)
    const dataItem = type === 'host' ? host : owner
    return (
        <div style={style}
             className={classNames('p-2 flex flex-col custom-item-render border border-color-50 hover:scale-3xs hover:shadow rounded-lg relative', className)}>
            {showLabel && (
                <React.Fragment>
                    <OverlayItemBanner
                        type={hostType}
                        title={hostType}
                    />
                    <div className="h-7"/>
                </React.Fragment>
            )}
            <HostContent
                item={dataItem}
                showInfo={showInfo}
            />
        </div>
    )
}

export default HostActionRow
